import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import LoginPage from '../pages/LoginPage';
import DashboardPage from '../pages/DashboardPage';
import ProtectedRoute from '../components/ProtectedRoute';
import MainLayout from '../components/MainLayout';
import CirclesListPage from '../pages/Circles/CirclesListPage';
import CircleDetailsPage from '../pages/Circles/CircleDetailsPage';
import ChallengesListPage from '../pages/Challenges/ChallengesListPage';
import ChallengeDetailsPage from '../pages/Challenges/ChallengeDetailsPage';
import ChallengeFormPage from '../pages/Challenges/ChallengeFormPage';
import CausesListPage from '../pages/Causes/CausesListPage';
import CauseFormPage from '../pages/Causes/CauseFormPage';
import CauseDetailsPage from '../pages/Causes/CauseDetailsPage';
import ReportingPage from '../pages/Reporting/ReportingPage';
import ContentControlPage from '../pages/Content/ContentControlPage';
import ImpactStoryListPage from '../pages/Content/ImpactStoryListPage';
import ImpactStoryFormPage from '../pages/Content/ImpactStoryFormPage';
import UserManagementPage from '../pages/Users/UserManagementPage';
import PointsConsolePage from '../pages/Points/PointsConsolePage';
import StreaksPage from '../pages/Streaks/StreaksPage';
import SettingsPage from '../pages/Settings/SettingsPage';
import RolesPermissionsPage from '../pages/RolesPermissions/RolesPermissionsPage';
import DonationTrackingListPage from '../pages/DonationTracking/DonationTrackingListPage';
import DonationTrackingDetailsPage from '../pages/DonationTracking/DonationTrackingDetailsPage';
import CauseTrackingConfigPage from '../pages/DonationTracking/CauseTrackingConfigPage';
import NotificationsListPage from '../pages/Notifications/NotificationsListPage';
import NotificationComposerPage from '../pages/Notifications/NotificationComposerPage';
import NotificationDetailsPage from '../pages/Notifications/NotificationDetailsPage';
import NotificationAnalyticsPage from '../pages/Notifications/NotificationAnalyticsPage';

const AppRouter = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <MainLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<DashboardPage />} />
          <Route path="users" element={<UserManagementPage />} />
          <Route path="points" element={<PointsConsolePage />} />
          <Route path="streaks" element={<StreaksPage />} />
          <Route path="circles" element={<CirclesListPage />} />
          <Route path="circles/:id" element={<CircleDetailsPage />} />
          <Route path="challenges" element={<ChallengesListPage />} />
          <Route
            path="challenges/new"
            element={
              <ProtectedRoute allowedRoles={['SuperAdmin', 'Content-Manager']}>
                <ChallengeFormPage />
              </ProtectedRoute>
            }
          />
          <Route path="challenges/:id" element={<ChallengeDetailsPage />} />
          <Route
            path="challenges/:id/edit"
            element={
              <ProtectedRoute allowedRoles={['SuperAdmin', 'Content-Manager']}>
                <ChallengeFormPage />
              </ProtectedRoute>
            }
          />
          <Route path="causes" element={<CausesListPage />} />
          <Route
            path="causes/new"
            element={
              <ProtectedRoute allowedRoles={['SuperAdmin', 'Content-Manager']}>
                <CauseFormPage />
              </ProtectedRoute>
            }
          />
          <Route path="causes/:id" element={<CauseDetailsPage />} />
          <Route
            path="causes/:id/edit"
            element={
              <ProtectedRoute allowedRoles={['SuperAdmin', 'Content-Manager']}>
                <CauseFormPage />
              </ProtectedRoute>
            }
          />
          <Route path="content" element={<ContentControlPage />} />
          <Route path="content/stories" element={<ImpactStoryListPage />} />
          <Route
            path="content/stories/new"
            element={
              <ProtectedRoute allowedRoles={['SuperAdmin', 'Content-Manager']}>
                <ImpactStoryFormPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="content/stories/:id/edit"
            element={
              <ProtectedRoute allowedRoles={['SuperAdmin', 'Content-Manager']}>
                <ImpactStoryFormPage />
              </ProtectedRoute>
            }
          />
          <Route path="analytics" element={<ReportingPage />} />
          <Route path="donation-tracking" element={<DonationTrackingListPage />} />
          <Route
            path="donation-tracking/:id"
            element={<DonationTrackingDetailsPage />}
          />
          <Route
            path="causes/:causeId/tracking-config"
            element={
              <ProtectedRoute allowedRoles={['SuperAdmin', 'Content-Manager']}>
                <CauseTrackingConfigPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="settings"
            element={
              <ProtectedRoute allowedRoles={['SuperAdmin', 'Content-Manager']}>
                <SettingsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="roles"
            element={
              <ProtectedRoute allowedRoles={['SuperAdmin']}>
                <RolesPermissionsPage />
              </ProtectedRoute>
            }
          />

          <Route path="notifications" element={<NotificationsListPage />} />
          <Route
            path="notifications/new"
            element={
              <ProtectedRoute allowedRoles={['SuperAdmin', 'Content-Manager']}>
                <NotificationComposerPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="notifications/analytics"
            element={<NotificationAnalyticsPage />}
          />
          <Route path="notifications/:id" element={<NotificationDetailsPage />} />

          <Route path="content/new" element={<ImpactStoryFormPage />} />
          <Route path="content/edit/:id" element={<ImpactStoryFormPage />} />
          <Route path="causes/edit/:id" element={<CauseFormPage />} />
          <Route path="reporting" element={<ReportingPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default AppRouter;
